import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const StartLabel = styled(Typography)`
    :hover {
        cursor: pointer;
    }
`

export default StartLabel
